export default __webpack_public_path__ + "img/3b71b2641fd3a16083ce4a7c421523e0.png";